// Actions for Calendar Month View / Program View

import DESIGNER_ACTIONS from '../designer/actions';
import DESIGNER_TOC_ACTIONS from '../designerTOC/actions';
import LIBRARY_ACTIONS from '../library/actions';
import FEED_ACTIONS from '../feed/actions';
import CLIPBOARD_ACTIONS from '../clipboard/actions';
import CALENDAR_COLLAPSE_ACTIONS from '../calendarCollapse/actions';

const CALENDAR_ACTIONS = {
    CALENDAR_ADD_FAKE_SESSION: 'calendar-add-fake-session',
    CALENDAR_ADD_PROGRAM_WORKOUTS: 'calendar-add-program-workouts',
    CALENDAR_ATHLETE_INFO: 'load-athlete-info',
    CALENDAR_EXTRA_CLEAR: 'calendar-extra-clear',
    CALENDAR_EXTRA_DATA: 'extra-work-load',
    CALENDAR_EXTRA_LOAD: 'calendar-extra-load',
    NUTRITION_LOAD: 'nutrition-load',
    NUTRITION_CLEAR: 'nutrition-clear',
    NUTRITION_LOADING: 'nutrition-loading',
    NUTRITION_LOADED: 'nutrition-loaded',
    CALENDAR_EXTRA_VIEW_OPTIONS: 'calendar-extra-view-options',
    CALENDAR_OPEN_AUTOPUBLISH_SETTINGS: 'calendar-open-autopublish-settings',
    CALENDAR_PROGRAMS_LOAD: 'calendar-programs-load',
    CALENDAR_PROGRAM_UPDATE_LENGTH: 'calendar-program-update-length',
    CALENDAR_PUBLISH_ALL: 'calendar-publish-all',
    CALENDAR_REMOVE_EXTRA: 'calendar-remove-extra',
    CALENDAR_SESSION_SELECT: 'calendar-session-select',
    CALENDAR_SET_PROGRAM_ID: 'calendar-set-programId',
    CALENDAR_SET_TEAM: 'calendar-set-team',
    CALENDAR_SETUP: 'calendar-setup',
    CALENDAR_TOGGLE_INSTRUCTIONS: 'calendar-toggle-instructions',
    CALENDAR_TOGGLE_BLOCK_NAMES: 'calendar-toggle-block-names',
    CLEAR_INFO_TREE: 'clear-info-tree',
    CONFIRM_DIALOG_VALUE: 'confirm-dialog-value',
    COPY_EDIT_SUBSCRIPTION: 'copy-edit-subscription',
    DAYS_CLEAR: 'calendar-days-clear',
    DAYS_RELOAD: 'calendar-days-reload',
    DND_CAL_SESSION: 'calendar-drop-workout',
    DND_CAL_SESSION_ORDER: 'calendar-drop-order',
    DRAWER_LOAD_INFO: 'calendar-drawer-load-info',
    FIXED_PROGRAMS_LOAD: 'calendar-fixed-programs-load',
    LIBRARY_SESSIONS_LOAD: 'calendar-library-sessions-load',
    SESSION_COPY: 'calendar-session-copy',
    SESSION_DELETE: 'calendar-session-delete',
    SESSION_DELETE_UNDO: 'calendar-session-delete-undo',
    SUBSCRIBED_TEAMS_LOAD: 'calendar-subscribed-teams-load',
    UI_ADD_DRAWER_DIALOG: 'calendar-ui-add-drawer-dialog',
    UI_CALENDAR_DAY_HOVER: 'calendar-ui-day-hover',
    UI_CALENDAR_DAY_SELECT: 'calendar-ui-day-select',
    UI_CALENDAR_DRAGGING: 'calendar-ui-dragging',
    UI_CALENDAR_SET_COLLAPSE: 'calendar-ui-set-collapse',
    UI_CALENDAR_SESSION_EDIT_URL: 'calendar-session-edit-url',
    UI_CALENDAR_SESSION_SCROLL_KEY: 'calendar-session-scroll-key',
    UI_CALENDAR_SIDENAV: 'calendar-ui-sidenav',
    UI_LOADING: 'calendar-ui-loading',
    UI_DELETE_DIALOG: 'calendar-ui-delete-dialog',
    UI_INFORM: 'calendar-ui-inform',
    UI_PREVIEW: 'calendar-ui-preview',
    UI_SAVING: 'calendar-ui-saving',
    UI_SET_TOOLTIP_CONTENT: 'calendar-ui-set-tooltip-content',
    UI_TOC_LOADING: 'calendar-ui-toc-loading',
    UI_RELOAD_DRAWER: 'calendar-reload-drawer',
    UI_DRAWER_LOADING: 'calendar-drawer-loading',
    UI_UPDATE_TOOLTIP_CONTENT: 'calendar-update-tooltip-content',
    UI_BASIC_DRAWER: 'calendar-basic-drawer'
};

// merging these for now because we share the
// reducer between the calendar and designer
const actions = Object.assign(
    {},
    DESIGNER_ACTIONS,
    CALENDAR_ACTIONS,
    DESIGNER_TOC_ACTIONS,
    LIBRARY_ACTIONS,
    FEED_ACTIONS,
    CLIPBOARD_ACTIONS,
    CALENDAR_COLLAPSE_ACTIONS
);
export default actions;



// WEBPACK FOOTER //
// ./src/state/reducer/calendar/actions.js